import './Globals';
import flyingPages from './FlyingPages';
import equalHeights from './EqualHeights';
import './UserMovement';
import './Accordion';
import './Links';
import './Pickadate';
import './WebVitals';
import jump from './Jump';
import {
    getParents,
    checkMatch,
    isNode,
    matches,
    nodeArray,
    getGrandChildren,
    bubbleUntil,
    removeNode,
} from './Functions';

const content = document.querySelector('main.content');

if (content) {
    flyingPages({ prefetch: content });
}

export {
    getParents,
    checkMatch,
    isNode,
    matches,
    nodeArray,
    getGrandChildren,
    bubbleUntil,
    removeNode,
    equalHeights,
    jump,
};
